import type { Reply } from 'models';
import type { User } from 'features/auth';
import { isSuperAdmin } from '../utils';

export const canDeleteSocialEventComment = ({
  comment,
  viewer: { nodeUserData, railsUserData },
}: {
  comment: Reply;
  viewer: User;
}) => isSuperAdmin({ viewer: railsUserData }) || nodeUserData._id === comment.author.id;

// TODO: for now, we allow all users to comment on social events
export const canCommentSocialEvent = () => true;
